import { axios } from '@/utils/request'

const api = {
    sihaoList: '/wyhadminapi/csihao/sihaoList',
    sihaoDetail: '/wyhadminapi/csihao/sihaoDetail',
    editSihao: '/wyhadminapi/csihao/editSihao',
  deleteSihao: '/wyhadminapi/csihao/sihaoDelete',
  memberList: '/wyhadminapi/csihao/memberList',
  memberDetail: '/wyhadminapi/csihao/memberDetail',
  memberEdit: '/wyhadminapi/csihao/memberEdit',
  memberDelete: '/wyhadminapi/csihao/memberDelete',
  sihaoDeleteAll: '/wyhadminapi/csihao/sihaoDeleteAll',
  sihaoDownloadUrl: '/wyhadminapi/csihao/sihaoDownloadUrl',
  sihaoImport: '/wyhadminapi/csihao/sihaoImport',
  setBaijiaAll: '/wyhadminapi/csihao/setBaijiaAll',
} 

export default api

export function getSihaoList(parameter) {
  return axios({
    url: api.sihaoList,
    method: 'get',
    params: parameter
  })
}

export function getSihaoDetail(parameter) {
  return axios({
    url: api.sihaoDetail,
    method: 'get',
    params: parameter
  })
}
export function editSihao(parameter) {
  return axios({
    url: api.editSihao,
    method: 'post',
    data: parameter
  })
}
export function deleteSihao(parameter) {
  return axios({
    url: api.deleteSihao,
    method: 'post',
    data: parameter
  })
}

export function sihaoDeleteAll(parameter) {
  return axios({
    url: api.sihaoDeleteAll,
    method: 'post',
    data: parameter
  })
}

export function getSihaoDownloadUrl(parameter) {
  return axios({
    url: api.sihaoDownloadUrl,
    method: 'get',
    params: parameter
  })
}
export function getApplyMemberList(parameter) {
  return axios({
    url: api.memberList,
    method: 'post',
    data: parameter
  })
}
export function memberEdit(parameter) {
  return axios({
    url: api.memberEdit,
    method: 'post',
    data: parameter
  })
}

export function memberDetail(parameter) {
  return axios({
    url: api.memberDetail,
    method: 'get',
    params: parameter
  })
}
export function memberDelete(parameter) {
  return axios({
    url: api.memberDelete,
    method: 'get',
    params: parameter
  })
}

 
export function sihaoImport(parameter) {
  return axios({
    url: api.sihaoImport,
    method: 'post',
    data: parameter
  })
}